








import {Component, Vue} from "vue-property-decorator";

@Component({}) export default class extends Vue {
    active = false;
    data = false;
    component = false;

    beforeMount() {
        this.$eventEmitter.subscribe("openPopup", this.openPopup.bind(this));
        this.$eventEmitter.subscribe("closePopup", this.closePopup.bind(this));
    }

    closePopup() {
        this.data = false;
        this.component = false;
        this.setActive(false);
    }

    openPopup(component, data) {
        this.component = component;
        this.data = data;
        this.setActive(true);
    }

    setActive(val) {
        this.active = val;
    }
}
